"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var PlanType = _interopRequireWildcard(require("../pricings/PlanType"));

var _createObjectValuesPropType = _interopRequireDefault(require("./createObjectValuesPropType"));

var _default = (0, _createObjectValuesPropType.default)(PlanType);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/propTypes/planType.js
// module id = 346
// module chunks = 209 210 211 212